import RequestMap from './RequestMap';
/** [객체변환] 다음 주소 > RequestMap */
export default class TransformDaumToRequestMap {
    data;
    constructor(daumData) {
        this.data = {
            id: 0,
            address: {
                siDo: daumData.address.region_1depth_name,
                siGunGu: daumData.address.region_2depth_name,
                buildingName: daumData.road_address.building_name,
                detail: '',
                administrativeArea: '',
                lotNumber: {
                    dong: daumData.address.region_3depth_name,
                    ri: '',
                    mainNumber: daumData.address.main_address_no,
                    subNumber: daumData.address.sub_address_no,
                },
                roadName: {
                    name: daumData.road_address.road_name,
                    mainBuildingNumber: daumData.road_address.main_building_no,
                    subBuildingNumber: daumData.road_address.sub_building_no,
                },
                location: {
                    latitude: daumData.y,
                    longitude: daumData.x,
                },
            },
        };
    }
    /**
     * 변환
     */
    make() {
        return new RequestMap(this.data);
    }
}
